export const rules = function () {
    return {
      carNo: [
        { required: true, message: '请输入车牌号', trigger: ['blur', 'change'] },
      ],
      vin: [
        { required: true, message: '请输入车架号', trigger: ['blur', 'change'] },
      ],
      engineNo: [
        { required: true, message: '请输入发动机号', trigger: ['blur', 'change'] },
      ],
      beginDate: [
        { required: true, message: '请输入初登日期', trigger: ['blur', 'change'] },
      ],
      usetype: [
        { required: true, message: '请输入使用性质', trigger: ['blur', 'change'] },
      ],
      brandType: [
        { required: true, message: '请输入品牌型号', trigger: ['blur', 'change'] },
      ],
      // passengerCount: [
      //   { required: true, message: '请输入核定载客', trigger: ['blur', 'change'] },
      // ],
    }
}

export default {}